// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"63e2f064","644":"be8579df","667":"a94c17dc"}[chunkId] + ".chunk.js";
};